module.exports = __webpack_public_path__ + "static/media/LemonIcon.14f95443.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LemonIcon.svg
// module id = 317
// module chunks = 0